/* media-gallery.js – kept as a no-op for backwards compatibility.
   The product gallery is now handled by inline JS in product-media-gallery.liquid. */
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}
